import React from 'react'

export const IconZenHub = () => (
  <svg
    viewBox='0 0 176 176'
    aria-hidden='true'
    focusable='false'
    height='25'
    className='icon-zenhub'
    data-icon='zenhub'
    role='img'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill='none' fillRule='evenodd'>
      <path fill='#5e60ba' d='M0 0v176h176V0H0' />
      <path
        fill='#fff'
        d='M131.98 146.06H44.09v-21.38l57.88-73.58H45.33V29.9h85.41v21.2l-58.07 73.58h59.31v21.38'
      />
    </g>
  </svg>
)
